export default __webpack_public_path__ + "static/media/campaign.f837dd69.png";